




























import JavaHttp from '@/common/network/JavaHttp'
import FuncUtils from '@/common/utils/FuncUtils'
import ValidateUtils from '@/common/utils/ValidateUtils'
import { UserModule } from '@/store/modules/user'
import { sm4Encode } from '@/utils/sm4util'
import { Base64 } from 'js-base64'
import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  name: 'BindAccout',
  components: {}
})
export default class LogBindAccoutin extends Vue {
  @Prop({ required: true }) public bindParmas!: any
  public form = {
    username: '',
    code: '',
    wxEnterpriseUserId: '',
    wxEnterpriseUserName: ''
  }
  public formRulers = {
    username: [
      { required: true, message: '请输入手机号码' },
      {
        validator: (rule: any, value: any, callback: Function) => {
          const ret = ValidateUtils.isMobilePhone(value)
          if (!ret.result) {
            if (value == 'admin') {
              callback()
            } else {
              callback(new Error(ret.hintMsg))
            }
          } else {
            callback()
          }
        }
      }
    ],
    code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
  }
  public visible = false
  public getCodeStatus = false
  public btnContent = '获取验证码'
  public bindLoading = false
  /**
   * 获取验证码
   */
  public getCode() {
    const form: any = this.$refs.ruleFormRef
    form.validateField('username', (msg: any) => {
      if (msg) {
        return
      }
      this.getCodeStatus = true
      const params = {
        phone: sm4Encode(this.form.username)
      }
      JavaHttp.postData('/public/auth/manageLoginCodeSend', params)
        .then((res: any) => {
          if (res.code == 0) {
            FuncUtils.hitMessageSuccess(res.msg || '验证码发送成功')
            this.btnContent = '重新获取(60秒)'
            let waitSecond = 60
            const timeId = setInterval(() => {
              waitSecond--
              if (waitSecond == 0) {
                this.btnContent = '获取验证码'
                this.getCodeStatus = false
                clearInterval(timeId)
                return
              }
              this.btnContent = '重新获取(' + waitSecond + '秒)'
            }, 1000)
          } else {
            FuncUtils.hitMessageError(res.msg || '系统错误，请稍后再试')
            this.btnContent = '获取验证码'
            this.getCodeStatus = false
          }
        })
        .catch(() => {
          FuncUtils.hitMessageError('系统错误，请稍后再试')
          this.getCodeStatus = false
        })
    })
  }
  /**
   * 绑定账号
   */
  public bindSubmit() {
    const form: any = this.$refs.ruleFormRef
    form.validate((valid: boolean) => {
      if (valid) {
        this.wechatBind()
        return true
      } else {
        return false
      }
    })
    // const res: any = await wechatBind(form)
    // if (res.code === 0) {
    //   setToken(res.data.token)
    //   router.push('/')
    // }
  }
  wechatBind() {
    this.bindLoading = true
    const { username, code, wxEnterpriseUserId, wxEnterpriseUserName } = this.form
    const params = {
      username: sm4Encode(username),
      code,
      wxEnterpriseUserId,
      wxEnterpriseUserName
    }
    JavaHttp.postData('/public/auth/common/wxBindAndLogin', params)
      .then((res: any) => {
        this.bindLoading = false
        if (res.code === 0) {
          FuncUtils.hitMessageSuccess(res.msg || '绑定成功')
          const info = Base64.decode(res.data.token).split(':')
          const user = {
            id: info[0],
            account: this.form.username,
            token: res.data.token
          }
          UserModule.saveUserInfo(user)
          this.$emit('getUserInfo', user.token)
        } else {
          FuncUtils.hitMessageError(res.msg || '绑定失败，请稍后再试')
        }
      })
      .catch(() => {
        FuncUtils.hitMessageError('系统错误，请稍后再试')
        this.bindLoading = false
      })
  }
  public show() {
    this.form.wxEnterpriseUserId = this.bindParmas.wxEnterpriseUserId
    this.form.wxEnterpriseUserName = this.bindParmas.wxEnterpriseUserName
    this.visible = true
  }
}
